module.exports = __webpack_public_path__ + "img/renault_thumbnail.b40799e6.png";